var _excluded = ["children", "compact", "cookies", "env", "globalNavigation", "mergeBasket", "searchedTerm"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useScrollbarWidth } from 'react-use';
import { setAppElement } from '@noths/polaris-client-ribbons-design-system';
import { createGlobalStyle } from 'styled-components';
import { GlobalNavigation } from "../../constants/featureFlags";
import { SiteChromeStaticContext } from "./SiteChromeStaticContext";
export var createSiteChromeStaticContextProvider = function createSiteChromeStaticContextProvider(appSelector, useScopedStyles) {
  var GlobalStyles = appSelector && createGlobalStyle([".ReactModal__Body--open{overflow:hidden;padding-right:", "px;}"], function (props) {
    return props.scrollBarWidth;
  });
  return function (_ref) {
    var children = _ref.children,
      _ref$compact = _ref.compact,
      compact = _ref$compact === void 0 ? false : _ref$compact,
      cookies = _ref.cookies,
      env = _ref.env,
      _ref$globalNavigation = _ref.globalNavigation,
      globalNavigation = _ref$globalNavigation === void 0 ? GlobalNavigation.LEGACY : _ref$globalNavigation,
      _ref$mergeBasket = _ref.mergeBasket,
      mergeBasket = _ref$mergeBasket === void 0 ? true : _ref$mergeBasket,
      searchedTerm = _ref.searchedTerm,
      props = _objectWithoutProperties(_ref, _excluded);
    var staticContextValue = {
      compact,
      cookies,
      env,
      globalNavigation,
      searchedTerm,
      mergeBasket,
      useScopedStyles
    };
    if (appSelector) {
      setAppElement(appSelector);
    }
    var scrollBarWidth = useScrollbarWidth();
    return /*#__PURE__*/React.createElement(React.Fragment, null, GlobalStyles && /*#__PURE__*/React.createElement(GlobalStyles, {
      scrollBarWidth: scrollBarWidth || 0
    }), /*#__PURE__*/React.createElement(SiteChromeStaticContext.Provider, _extends({
      value: staticContextValue
    }, props), children));
  };
};